export default "__VITE_ASSET__CR3Rf1Yp__"